(function () {
  'use strict';

  const SUPABASE_URL = 'https://xoolcbbpnvdylcoorlqg.supabase.co';
  const PUBLISHABLE_KEY = 'sb_publishable_bjOrV5qp2n0PtuVFOSA_6g_3Micws2T';

  function getSession() {
    try {
      const key = Object.keys(localStorage).find(
        (k) => k.includes('sb-') && k.endsWith('-auth-token')
      );

      if (!key) return null;

      return JSON.parse(localStorage.getItem(key));
    } catch (error) {
      console.error('[Corevian Admin Review] Session error:', error);
      return null;
    }
  }

  function getAccessToken() {
    return getSession()?.access_token || null;
  }

  async function rpc(functionName, payload = {}) {
    const accessToken = getAccessToken();

    if (!accessToken) {
      throw new Error('No active Corevian University session was found.');
    }

    const response = await fetch(
      `${SUPABASE_URL}/rest/v1/rpc/${functionName}`,
      {
        method: 'POST',
        headers: {
          apikey: PUBLISHABLE_KEY,
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }
    );

    const text = await response.text();

    let body = null;

    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = text;
    }

    if (!response.ok) {
      throw new Error(
        body?.message ||
        body?.details ||
        body?.error ||
        `Request failed with status ${response.status}`
      );
    }

    return body;
  }

  async function restGet(path) {
    const accessToken = getAccessToken();

    if (!accessToken) {
      throw new Error('No active Corevian University session was found.');
    }

    const response = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, {
      method: 'GET',
      headers: {
        apikey: PUBLISHABLE_KEY,
        Authorization: `Bearer ${accessToken}`
      }
    });

    const text = await response.text();

    let body = null;

    try {
      body = text ? JSON.parse(text) : null;
    } catch {
      body = text;
    }

    if (!response.ok) {
      throw new Error(
        body?.message ||
        body?.details ||
        body?.error ||
        `Request failed with status ${response.status}`
      );
    }

    return body;
  }

  function escapeHtml(value) {
    return String(value ?? '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  async function resolveVersionId(row) {
    const directId =
      row.document_version_id ||
      row.version_id ||
      row.controlled_document_version_id;

    if (directId) return directId;

    const documentCode = row.document_code;
    const versionNumber = row.version_number;

    if (!documentCode || !versionNumber) {
      throw new Error(
        'Unable to identify this document version. Document code or version number is missing.'
      );
    }

    const documents = await restGet(
      `controlled_documents?select=id&document_code=eq.${encodeURIComponent(documentCode)}&limit=1`
    );

    if (!Array.isArray(documents) || !documents.length) {
      throw new Error(`Document ${documentCode} could not be found.`);
    }

    const documentId = documents[0].id;

    const versions = await restGet(
      `controlled_document_versions?select=id&document_id=eq.${encodeURIComponent(documentId)}&version_number=eq.${encodeURIComponent(versionNumber)}&limit=1`
    );

    if (!Array.isArray(versions) || !versions.length) {
      throw new Error(
        `Version ${versionNumber} for ${documentCode} could not be found.`
      );
    }

    return versions[0].id;
  }

  function injectStyles() {
    if (document.getElementById('cvnAdminReviewStyles')) return;

    const style = document.createElement('style');
    style.id = 'cvnAdminReviewStyles';

    style.textContent = `
      #cvnSubmitReviewLauncher {
        appearance: none;
        border: 1px solid #536178;
        background: #17243a;
        color: #ffffff;
        font-weight: 700;
        padding: 10px 16px;
        border-radius: 8px;
        cursor: pointer;
        margin-left: 10px;
      }

      #cvnSubmitReviewLauncher:hover {
        border-color: #19B5B0;
      }

      #cvnReviewOverlay {
        position: fixed;
        inset: 0;
        z-index: 12100;
        background: rgba(3, 8, 18, .80);
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 24px;
      }

      #cvnReviewPanel {
        width: min(700px, 96vw);
        max-height: 90vh;
        overflow-y: auto;
        background: #0B1426;
        color: #ffffff;
        border: 1px solid rgba(25,181,176,.35);
        border-radius: 16px;
        padding: 26px;
        box-shadow: 0 24px 70px rgba(0,0,0,.45);
      }

     #cvnReviewPanel h2 {
     margin: 0 0 7px;
     font-size: 25px;
     color: #ffffff !important;
    }

      .cvn-review-subtitle {
        color: #ffffff !important;
        line-height: 1.5;
        margin-bottom: 22px;
      }

      #cvnReviewMessage {
        display: none;
        margin-bottom: 16px;
        padding: 11px 13px;
        border-radius: 8px;
      }

      #cvnReviewMessage.success {
        display: block;
        background: rgba(25,181,176,.14);
        border: 1px solid rgba(25,181,176,.45);
        color: #cffffb;
      }

      #cvnReviewMessage.error {
        display: block;
        background: rgba(190,65,65,.13);
        border: 1px solid rgba(210,80,80,.45);
        color: #ffd2d2;
      }

      .cvn-review-field {
        margin-bottom: 20px;
      }

      .cvn-review-field label {
        display: block;
        font-size: 13px;
        font-weight: 700;
        color: #d7e0ec;
        margin-bottom: 7px;
      }

      .cvn-review-field select {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid #31415a;
        background: #111d31;
        color: #ffffff;
        border-radius: 8px;
        padding: 12px;
        font: inherit;
      }

      .cvn-review-notice {
        margin: 18px 0 22px;
        padding: 13px 14px;
        border-left: 3px solid #19B5B0;
        background: rgba(25,181,176,.07);
        color: #c7d2df;
        line-height: 1.55;
        font-size: 14px;
      }

      .cvn-review-actions {
        display: flex;
        justify-content: flex-end;
        gap: 10px;
        border-top: 1px solid #26354c;
        padding-top: 20px;
      }

      .cvn-review-actions button {
        border-radius: 8px;
        padding: 11px 18px;
        font-weight: 700;
        cursor: pointer;
      }

      #cvnReviewCancel {
        background: transparent;
        border: 1px solid #536178;
        color: #ffffff;
      }

      #cvnReviewSubmit {
        background: #19B5B0;
        border: 1px solid #19B5B0;
        color: #07101f;
      }

      #cvnReviewSubmit:disabled {
        opacity: .55;
        cursor: not-allowed;
      }

      .cvn-review-empty {
        padding: 18px;
        border: 1px solid #31415a;
        border-radius: 9px;
        color: #aab6c9;
      }
        /* FIX — ASSIGN DOCUMENT MODAL HEADING */
      #cvnAssignPanel h2 {
       color: #ffffff !important;
     }
    `;
    

    document.head.appendChild(style);
  }

  function closeModal() {
    document.getElementById('cvnReviewOverlay')?.remove();
  }

  function showMessage(message, type) {
    const el = document.getElementById('cvnReviewMessage');
    if (!el) return;

    el.className = type;
    el.textContent = message;
  }

  async function refreshAdminRegister() {
    const adminOverlay = document.getElementById('cvnAdminDocsOverlay');

    if (!adminOverlay) return;

    const refreshButton = Array.from(
      adminOverlay.querySelectorAll('button')
    ).find(
      (button) => button.textContent.trim() === 'Refresh Register'
    );

    if (refreshButton) {
      setTimeout(() => refreshButton.click(), 300);
    }
  }

  async function openReviewModal() {
    if (document.getElementById('cvnReviewOverlay')) return;

    const overlay = document.createElement('div');
    overlay.id = 'cvnReviewOverlay';

    overlay.innerHTML = `
      <div id="cvnReviewPanel">
        <h2>Submit Controlled Document for Review</h2>

        <div class="cvn-review-subtitle">
          Select a draft controlled-document version to move into formal review.
        </div>

        <div id="cvnReviewMessage"></div>

        <div id="cvnReviewContent">
          Loading eligible drafts...
        </div>
      </div>
    `;

    document.body.appendChild(overlay);

    try {
      const register = await rpc(
        'get_admin_controlled_document_register',
        {}
      );

      if (!Array.isArray(register)) {
        throw new Error('The controlled-document register could not be loaded.');
      }

      const drafts = register.filter(
        (row) =>
          String(row.version_status || '').toLowerCase() === 'draft'
      );

      const content = document.getElementById('cvnReviewContent');

      if (!drafts.length) {
        content.innerHTML = `
          <div class="cvn-review-empty">
            No controlled-document drafts are currently eligible for review.
          </div>

          <div class="cvn-review-actions">
            <button id="cvnReviewCancel" type="button">Close</button>
          </div>
        `;

        document
          .getElementById('cvnReviewCancel')
          .addEventListener('click', closeModal);

        return;
      }

      const options = drafts
        .map((row, index) => {
          const code = escapeHtml(row.document_code);
          const title = escapeHtml(row.title);
          const version = escapeHtml(row.version_number);

          return `
            <option value="${index}">
              ${code} — ${title} — Version ${version}
            </option>
          `;
        })
        .join('');

      content.innerHTML = `
        <div class="cvn-review-field">
          <label for="cvnReviewDraftSelect">Draft Document *</label>

          <select id="cvnReviewDraftSelect">
            ${options}
          </select>
        </div>

        <div class="cvn-review-notice">
          Submitting a document for review does not approve it and does not make
          it operational. Its status will change from Draft to Under Review.
        </div>

        <div class="cvn-review-actions">
          <button id="cvnReviewCancel" type="button">Cancel</button>
          <button id="cvnReviewSubmit" type="button">Submit for Review</button>
        </div>
      `;

      document
        .getElementById('cvnReviewCancel')
        .addEventListener('click', closeModal);

      document
        .getElementById('cvnReviewSubmit')
        .addEventListener('click', async function () {
          const button = this;
          const select =
            document.getElementById('cvnReviewDraftSelect');

          const selectedIndex = Number(select.value);
          const selectedRow = drafts[selectedIndex];

          if (!selectedRow) {
            showMessage('Please select a valid draft document.', 'error');
            return;
          }

          const code = selectedRow.document_code;
          const version = selectedRow.version_number;

          button.disabled = true;
          button.textContent = 'Submitting...';

          try {
            const versionId = await resolveVersionId(selectedRow);

            const result = await rpc(
              'submit_controlled_document_for_review',
              {
                p_document_version_id: versionId
              }
            );

            console.log(
              '[Corevian Admin Review] Submitted for review:',
              result
            );

            showMessage(
              `${code} Version ${version} was submitted for review successfully.`,
              'success'
            );

            await refreshAdminRegister();

            setTimeout(closeModal, 1400);

          } catch (error) {
            console.error(
              '[Corevian Admin Review] Submit failed:',
              error
            );

            showMessage(
              error.message || 'Unable to submit document for review.',
              'error'
            );

            button.disabled = false;
            button.textContent = 'Submit for Review';
          }
        });

    } catch (error) {
      console.error(
        '[Corevian Admin Review] Unable to load drafts:',
        error
      );

      const content = document.getElementById('cvnReviewContent');

      content.innerHTML = `
        <div class="cvn-review-empty">
          Unable to load eligible drafts.
        </div>

        <div class="cvn-review-actions">
          <button id="cvnReviewCancel" type="button">Close</button>
        </div>
      `;

      showMessage(error.message, 'error');

      document
        .getElementById('cvnReviewCancel')
        .addEventListener('click', closeModal);
    }
  }

  function installLauncher() {
    const adminOverlay = document.getElementById('cvnAdminDocsOverlay');

    if (!adminOverlay) return false;

    if (document.getElementById('cvnSubmitReviewLauncher')) {
      return true;
    }

    const createButton =
      document.getElementById('cvnCreateDraftBtn');

    const refreshButton = Array.from(
      adminOverlay.querySelectorAll('button')
    ).find(
      (button) => button.textContent.trim() === 'Refresh Register'
    );

    const anchor = createButton || refreshButton;

    if (!anchor) return false;

    const button = document.createElement('button');

    button.id = 'cvnSubmitReviewLauncher';
    button.type = 'button';
    button.textContent = 'Submit for Review';

    if (createButton) {
      createButton.insertAdjacentElement('afterend', button);
    } else {
      refreshButton.insertAdjacentElement('beforebegin', button);
    }

    button.addEventListener('click', openReviewModal);

    return true;
  }

  function start() {
    injectStyles();
    installLauncher();

    const observer = new MutationObserver(function () {
      installLauncher();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();